import { Card, Result } from "antd";

import "./style.css";
const AboutUs = () => {
  return (
    <div className="notfound-container">
      <Card className="aboutus-card">
        <Result
          status="500"
          title="500"
          subTitle="متاسفانه برای سرور مشکلی پیش آمده است.بعدا مجدد امتحان کنید."
          extra={
            <a href="/" type="primary">
              بازگشت به صفحه اصلی
            </a>
          }
        />
      </Card>
    </div>
  );
};

export default AboutUs;
